
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from "@angular/material/icon";

export interface DropdownOption {
  key: string;
  value: string;
}

export interface ConfirmDialogData {
  title: string;
  message1: string;
  message2?: string;
  icon?: string;

  iconType?: string;
  yesText?: string;
  noText?: string;

  component?: string;

  radioOptions?: string[];
  dropdownOptions?: DropdownOption[];
  dropdownLabel?: string;
  defaultSelection?: string;
}


@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  imports: [MatButtonModule, MatIcon, CommonModule, FormsModule], 
  templateUrl: './confirmation-dialog.html',
  styleUrl: './confirmation-dialog.css',
})
export class ConfirmationDialog implements OnInit{

  selectedOption: string = '';
  selectedKey: string = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  ngOnInit() {
    this.selectedOption = this.data.defaultSelection || '';
    if (this.data.dropdownOptions?.length) {
      this.selectedKey = this.data.defaultSelection || this.data.dropdownOptions[0].key;
    }
  }

  onConfirm() {
    if (this.data.dropdownOptions?.length) {
      this.dialogRef.close({
        confirmed: true,
        value: this.selectedKey,
      });
    } else {
      this.dialogRef.close({
        confirmed: true,
        value: this.selectedOption,
      });
    }
  }

  onCancel() {
    this.dialogRef.close({
      confirmed: false
    });
  }
}